// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.5 10.25V5C2.5 3.9 3.4 3 4.5 3H11.5C12.6 3 13.5 3.9 13.5 5V10.25',
  'M2.5 10.25H13.5L14.4 11.65C14.82 12.31 14.38 13 13.6 13H2.4C1.62 13 1.18 12.31 1.6 11.65L2.5 10.25Z',
];
